import React from 'react';
import ManagementDashboardFilters from '../Management/ManagementDashboardFilters';
import InventoryProgressionView from '../Management/InventoryProgressionView';

const InventoryProgressionTab = ({ filters, onFiltersChange, onFiltersLoadingChange }) => {
  return (
    <div className="w-full pt-[5rem] pl-5 pr-5 pb-8">
      <div className="flex w-full flex-col gap-5">
        <div className="max-w-[280px]">
          <ManagementDashboardFilters
            onFiltersChange={onFiltersChange}
            onLoadingChange={onFiltersLoadingChange}
            initialProjectID={filters?.projectID}
            initialMonth={filters?.month}
          />
        </div>

        <InventoryProgressionView
          key={
            filters?.projectID != null && String(filters.projectID) !== ''
              ? Number(filters.projectID)
              : 'none'
          }
          projectID={filters?.projectID}
        />
      </div>
    </div>
  );
};

export default InventoryProgressionTab;
